import LegitIcon from '~/assets/icons/Legit';
import ShippingIcon from '~/assets/icons/Shipping';
import TickIcon from '~/assets/icons/Tick';

const cardData = [
  {
    description: 'All our sellers are fully verified.',
    icon: <TickIcon height="32px" width="32px" fill="#000000" />,
    title: 'Trust and reputation'
  },
  {
    description: 'Our authentication system is fast and effective.',
    icon: <LegitIcon />,
    title: 'Legit check'
  },
  {
    description: 'Orders typically delivered in 2-4 working days.',
    icon: <ShippingIcon height="33px" width="32px" fill="#000000" />,
    title: 'Fast shipping'
  }
];

type SoleMarketInfoCardProps = {
  description: string;
  icon: React.ReactNode;
  title: string;
};

const SoleMarketInfoCard = ({
  title,
  description,
  icon
}: SoleMarketInfoCardProps) => {
  return (
    <div className="flex w-full items-center gap-2 rounded-lg bg-concrete p-4">
      <div>{icon}</div>
      <div>
        <h3 className="text-lg font-bold">{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

const SoleMarketInfo = () => {
  return (
    <div className="bg-grey-tile">
      <div className="content-width flex flex-col gap-2 py-6 lg:py-12">
        <div className="flex flex-col gap-2 lg:flex-row">
          {cardData.map(({ title, description, icon }, index) => (
            <SoleMarketInfoCard
              key={index}
              title={title}
              description={description}
              icon={icon}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SoleMarketInfo;
